"use client";

import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";

export function DatadogRumInit() {
  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
    const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

    if (!appId || !clientToken) return;

    datadogRum.init({
      applicationId: appId,
      clientToken,
      site: "datadoghq.com",
      service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
      env: process.env.NEXT_PUBLIC_DATADOG_ENV,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackBfcacheViews: true,
      defaultPrivacyLevel: "mask-user-input",
    });
  }, []);

  return null;
}
